import React from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../../../context/AuthContext";
import ServiceCalendarTab from "./ServiceCalendarTab";

export default function TenantServiceCalendarPage() {
  const { selectedTenant } = useAuth();
  const history = useHistory();

  if (!selectedTenant?.tenantId) {
    return <div className="page-container"><div className="calendar-state">Select an organisation to view its calendar.</div></div>;
  }

  return (
    <div className="page-container">
      <ServiceCalendarTab
        tenantId={selectedTenant.tenantId}
        onOpenInstance={(serviceId, serviceInstanceId) =>
          history.push(`/services/${serviceId}/session-reports?serviceInstanceId=${serviceInstanceId}`)
        }
      />
    </div>
  );
}
